export const environment = {
  appRoot: '/acqdataroomcafe',
  production: true,
  loginUrl: '/content2/access/login',
  apiPrefix: {
    rootPath: '/api/',
    coreRootPath: '/api/',
    connect: '/api/connect/',
  },
  logo: '/api/createaccount/companylogo.png?imglogoColumn=loginlogo&1=1',
  GetAuthenticationTypeUrl: '/api/common/GetAuthenticationType',
  homepageRoute: '/content2/dashboard',
  productName: "acqdataroomcafe",
	favIcon: "/content2/assets/images/favicon.ico",
  appMode: "acqdataroomcafe"
};
